import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicRule, RuleEntity } from '@pdqdev/pdq-shared/dist/entities/Rules';
import { CartControlFormGroup } from '../../cart-control-form.component';

@Component({
  selector: 'cart-control-form-display-conditions',
  templateUrl: './cart-control-form-display-conditions.component.html',
  styleUrl: './cart-control-form-display-conditions.component.scss',
  standalone: false,
})
export class CartControlFormDisplayConditionsComponent {
  @Input() formGroup: FormGroup<CartControlFormGroup>;
  @Input() displayRules: DynamicRule[];
  @Input() displayRulesEntities: RuleEntity[];
  @Input() shopCurrencySymbol: string;
}
